<template>
<div class="container-fluid" style=" padding-top: 90px; padding-bottom: 90px; background-color: #f7f9fc;">
  <div class="container">
    <div class="row">
      <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
        <img src="@/assets/airManagement.jpg" class="col" style="" alt="">
      </div>
      <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
        <h3 class="pl-3" style="font-weight: bold;">{{ $t("airH") }}</h3>
        <p class="pl-3">{{ $t("airP1") }}</p>
        <p class="pl-3">{{ $t("airP2") }}</p>
        <div class="row pl-3">
          <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
            <h5 style="font-weight: bold;">{{ $t("airH1") }}</h5>
            <p>{{ $t("airP3") }}</p>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
            <h5 style="font-weight: bold;">{{ $t("airH2") }}</h5>
            <p>{{ $t("airP4") }}</p>
          </div>
        </div>
        <div class="col mt-3">
          <img src="@/assets/manager.png" style="width: 70px; border-radius: 10%;" alt="">
          <h5 style="font-weight: bold;">{{ $t("airManager") }}</h5>
          <p>eka.natsvlishvili@digisense.ge</p>
        </div>
      </div>
    </div>
  </div>
</div> 
</template>

<script>

export default {
  name: 'AirPms',
  data(){
      return{
       
        }
  },
  async mounted(){
  },

  methods : {
      
  },

  components: {

  },
  props: {

  },
      
 computed: {
  },
}

</script>

<style scoped>
.pad{
    /* padding: 15px;  */
    /* height: 200px; */
    line-height: 120px;
    /* font-weight: 550; */
}


</style>
